export default __webpack_public_path__ + "static/media/harmoneyes-3.807e47ce.jpg";